import { cva, RecipeVariantProps } from "styled-system/css";

export type MenuVariants = NonNullable<RecipeVariantProps<typeof menu>>;

export const menu = cva({
  base: {
    overflow: "auto",
    bg: "background.primary",
    color: "text.tertiary",
    rounded: "300",
    borderWidth: "100",
    borderColor: "border.secondary",
    shadow: "default",
    zIndex: "popover",
    outline: "[none]",
    minW: "min",
    "& > :first-child": {
      borderTopLeftRadius: "primary",
      borderTopRightRadius: "primary",
    },
    "& > :last-child": {
      borderBottomLeftRadius: "primary",
      borderBottomRightRadius: "primary",
    },
    _open: { animationStyle: "fade-in" },
    _closed: { animationStyle: "fade-out" },
  },
  variants: {
    size: {
      // Set the max-height of the menu to 6 items
      xs: {
        maxH: "[calc(6 * {spacing.24})]",
      },
      sm: {
        maxH: "[calc(6 * {spacing.32})]",
      },
      md: {
        maxH: "[calc(6 * {spacing.40})]",
      },
      lg: {
        maxH: "[calc(6 * {spacing.48})]",
      },
    },
  },
  defaultVariants: { size: "md" },
});

export const menuItem = cva({
  base: {
    display: "flex",
    alignItems: "center",
    gap: "8",
    bg: "background.primary",
    color: "text.tertiary",
    cursor: "pointer",
    _highlighted: {
      color: "text.secondary",
    },
    _selected: {
      color: "text.secondary",
      bg: "background.secondary",
    },
    _active: {
      color: "text.primary",
      "& svg": { color: "text.primary" },
    },
    _disabled: {
      cursor: "not-allowed",
      color: "text.disabled!",
    },
    transitionPreset: "colors",
  },
  variants: {
    isSelected: {
      true: {
        color: "text.secondary",
      },
    },
    size: {
      xs: {
        textStyle: { base: "body.md", desktop: "body.sm" },
        p: "4",
      },
      sm: {
        textStyle: { base: "body.md", desktop: "body.sm" },
        px: "8",
        py: "8",
      },
      md: {
        textStyle: { base: "body.lg", desktop: "body.md" },
        px: "12",
        py: "[10px]",
      },
      lg: {
        textStyle: { base: "body.xl", desktop: "body.xl" },
        px: "16",
        py: "12",
      },
    },
  },
  defaultVariants: { size: "md" },
});
